var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 4.93333C10.2121 4.93333 10.4156 4.84904 10.5656 4.69901C10.7157 4.54898 10.8 4.3455 10.8 4.13333C10.8 3.92116 10.7157 3.71767 10.5656 3.56764C10.4156 3.41761 10.2121 3.33333 9.99995 3.33333C9.78778 3.33333 9.58429 3.41761 9.43427 3.56764C9.28424 3.71767 9.19995 3.92116 9.19995 4.13333C9.19995 4.3455 9.28424 4.54898 9.43427 4.69901C9.58429 4.84904 9.78778 4.93333 9.99995 4.93333ZM9.99995 10.8C10.2121 10.8 10.4156 10.7157 10.5656 10.5657C10.7157 10.4157 10.8 10.2122 10.8 9.99999C10.8 9.78782 10.7157 9.58434 10.5656 9.43431C10.4156 9.28428 10.2121 9.19999 9.99995 9.19999C9.78778 9.19999 9.58429 9.28428 9.43427 9.43431C9.28424 9.58434 9.19995 9.78782 9.19995 9.99999C9.19995 10.2122 9.28424 10.4157 9.43427 10.5657C9.58429 10.7157 9.78778 10.8 9.99995 10.8ZM9.99995 16.6667C10.2121 16.6667 10.4156 16.5824 10.5656 16.4323C10.7157 16.2823 10.8 16.0788 10.8 15.8667C10.8 15.6545 10.7157 15.451 10.5656 15.301C10.4156 15.1509 10.2121 15.0667 9.99995 15.0667C9.78778 15.0667 9.58429 15.1509 9.43427 15.301C9.28424 15.451 9.19995 15.6545 9.19995 15.8667C9.19995 16.0788 9.28424 16.2823 9.43427 16.4323C9.58429 16.5824 9.78778 16.6667 9.99995 16.6667Z",
    stroke: "#8C8A94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.1fba6d578eebf261b0b938ddd845b2f8.svg";
export { ForwardRef as ReactComponent };